import { EVENT_NAME } from '@/constants/analytics'

export const TOUR = {
  APP: {
    name: 'App',
    eventName: EVENT_NAME.APP_TOUR
  },
  CREATE_GOAL: {
    name: 'Create Goal',
    eventName: EVENT_NAME.CREATE_GOAL
  },
  GIVE_AWARD: {
    name: 'Give Award',
    eventName: EVENT_NAME.GIVE_AWARD
  },
  KR_AWARD_ICON: {
    name: 'KR Award',
    eventName: EVENT_NAME.KR_AWARD
  }
}
